import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Season } from "../components/Form/Season";
import { Challenge } from "../components/Form/Challenge";
import { challengeObj } from "../components/Form/ChallengeBlock";
import { useEffect, useState } from "react";
import { generateUUID } from "../components/helpers/uuidgenerator.js";
import Community from "../components/Form/Community";
import { useData } from "../components/context/data/DataState";
import { useAuth } from "../components/context/auth/AuthState";
import { Alert, AlertDescription } from "../components/ui/alert";
import { Button } from "../components/ui/button";
import { ChevronLeft, ChevronRight, AlertCircle, CheckCircle2 } from "lucide-react";

export const Form = () => {
  const {
    data,
    communityId,
    changeCommunityId,
    seasonId,
    userPersonalData,
  } = useData();
  const { currentUser } = useAuth();
  const { community_id } = useParams();
  const navigate = useNavigate();
  const [viewPrev, setviewPrev] = useState(false);
  const [viewNext, setviewNext] = useState(false);
  const [alert, setalert] = useState({ msg: "", type: "success" });

  useEffect(() => {
    if (
      userPersonalData &&
      userPersonalData.allow_community_creation !== undefined
    ) {
      if (userPersonalData.allow_community_creation === 0) {
        navigate("/admin");
      }
    }
  }, [userPersonalData]);

  useEffect(() => {
    if (alert.msg) {
      setTimeout(() => {
        setalert({ msg: "", type: "success" });
      }, 15000);
    }
  }, [alert]);

  let [formStates, setFormStates] = useState({
    step: 1,
    community: {
      community_id: "o" + String(generateUUID()),
      community_name: "",
      description: "",
      locality: userPersonalData.locality || "",
      pincode: userPersonalData.pincode || "",
      city: userPersonalData.city || "",
      state: userPersonalData.state || "",
      country: userPersonalData.country || "India",
      access: "Open",
    },
    seasonArray: [],
    season_id: "new",
    season: {
      season_id: "s" + String(generateUUID()),
      season_name: "",
      description: "",
      start_date: "",
      end_date: "",
      challengeId: 1,
      user_id: currentUser.user_id,
    },
    challenge: [{ ...challengeObj(generateUUID(), currentUser.user_id) }],
    deleted: {
      season: [],
      challenge: [],
      group: [],
      event: [],
      task: [],
    },
  });

  useEffect(() => {
    if (
      community_id &&
      !Object.keys(data.community || {}).includes(community_id)
    ) {
      navigate("/admin");
    }
    if (community_id) {
      changeCommunityId(community_id);
    }
    if (community_id === communityId && communityId) {
      setFormStates((prev) => {
        return {
          ...prev,
          step: 1,
          community: {
            community_id: data.community[communityId].community_id,
            community_name: data.community[communityId].community_name,
            description: data.community[communityId].description,
            locality: data.community[communityId].locality,
            pincode: data.community[communityId].pincode,
            city: data.community[communityId].city,
            state: data.community[communityId].state,
            country: data.community[communityId].country,
            access: data.community[communityId].access,
          },
          seasonArray: Object.values(data.community[communityId].season).map(
            (s) => {
              return {
                ...s,
                challenge: Object.values(s.challenge).map((c) => {
                  return {
                    ...c,
                    user_id: currentUser.user_id,
                    task: Object.values(c.task),
                    event: Object.values(c.event),
                    group: Object.values(c.group),
                  };
                }),
              };
            }
          ),
          season_id: "new",
          season: {
            season_id: "s" + String(generateUUID()),
            season_name: "",
            description: "",
            start_date: "",
            end_date: "",
            challengeId: 1,
            user_id: currentUser.user_id,
          },
          challenge: [{ ...challengeObj(generateUUID(), currentUser.user_id) }],
        };
      });
      if (
        seasonId !== -1 &&
        Object.keys(data.community[communityId].season || {}).includes(seasonId)
      ) {
        setFormStates((prev) => ({
          ...prev,
          season: {
            ...prev.season,
            season_id: data.community[communityId].season[seasonId].season_id,
            season_name:
              data.community[communityId].season[seasonId].season_name,
            description:
              data.community[communityId].season[seasonId].description,
            start_date: new Date(
              data.community[communityId].season[seasonId].start_date
            ),
            end_date: new Date(
              data.community[communityId].season[seasonId].end_date
            ),
            challengeId:
              data.community[communityId].season[seasonId].challenge.length,
            user_id: currentUser.user_id,
          },
          seasonArray: Object.values(data.community[communityId].season).map(
            (s) => {
              return {
                ...s,
                community_id: communityId,
                user_id: currentUser.user_id,
                challenge: Object.values(s.challenge).map((c) => {
                  return {
                    ...c,
                    user_id: currentUser.user_id,
                    task: Object.values(c.task),
                    event: Object.values(c.event),
                    group: Object.values(c.group),
                    season_id: s.season_id,
                  };
                }),
              };
            }
          ),
          season_id: seasonId,
          challenge: Object.values(
            data.community[communityId].season[seasonId].challenge
          ).map((c) => {
            return {
              ...c,
              start_date: new Date(c.start_date),
              end_date: new Date(c.end_date),
              user_id: currentUser.user_id,
              task: Object.values(c.task),
              event: Object.values(c.event),
              group: Object.values(c.group),
            };
          }),
        }));
      }
    }
  }, [communityId]);

  let prevStep = (e) => {
    e.preventDefault();
    if (formStates.step > 1) {
      setFormStates((prev) => ({ ...prev, step: prev.step - 1 }));
    }
  };

  let nextStep = (e) => {
    e?.preventDefault();
    if (formStates.step < 3) {
      setFormStates((prev) => ({ ...prev, step: prev.step + 1 }));
    }
  };

  const select = (fSS) => {
    switch (fSS) {
      case 1:
        return (
          <Community
            formStates={formStates}
            setFormStates={setFormStates}
            nextStep={nextStep}
            setviewPrev={setviewPrev}
            setviewNext={setviewNext}
            setalert={setalert}
          />
        );
      case 2:
        return (
          <Season
            formStates={formStates}
            setFormStates={setFormStates}
            setviewPrev={setviewPrev}
            setviewNext={setviewNext}
            setalert={setalert}
          />
        );
      case 3:
        return (
          <Challenge
            formStates={formStates}
            setFormStates={setFormStates}
            setviewPrev={setviewPrev}
            setviewNext={setviewNext}
            setalert={setalert}
          />
        );
      default:
        return "Case not defined";
    }
  };

  const steps = [
    { number: 1, title: "Community", description: "Basic information" },
    { number: 2, title: "Season", description: "Season details" },
    { number: 3, title: "Challenges", description: "Tasks & events" },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 py-8 px-4">
      <div className="max-w-5xl mx-auto space-y-6">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent mb-2">
            {community_id ? "Edit Community" : "Create New Community"}
          </h1>
          <p className="text-gray-600">
            {community_id
              ? "Update your community settings and manage seasons"
              : "Set up your community and create your first season"}
          </p>
        </div>

        {/* Progress Indicator */}
        <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
          <div className="flex items-center justify-between">
            {steps.map((step, index) => (
              <React.Fragment key={step.number}>
                <div className="flex flex-col items-center flex-1">
                  <div
                    className={`w-10 h-10 rounded-full flex items-center justify-center font-semibold transition-all ${
                      formStates.step === step.number
                        ? "bg-gradient-to-r from-blue-600 to-purple-600 text-white scale-110"
                        : formStates.step > step.number
                        ? "bg-green-500 text-white"
                        : "bg-gray-200 text-gray-600"
                    }`}
                  >
                    {formStates.step > step.number ? "✓" : step.number}
                  </div>
                  <div className="mt-2 text-center">
                    <p
                      className={`text-sm font-medium ${
                        formStates.step === step.number
                          ? "text-blue-600"
                          : "text-gray-600"
                      }`}
                    >
                      {step.title}
                    </p>
                    <p className="text-xs text-gray-500">{step.description}</p>
                  </div>
                </div>
                {index < steps.length - 1 && (
                  <div
                    className={`flex-1 h-1 mx-4 rounded transition-all ${
                      formStates.step > step.number
                        ? "bg-green-500"
                        : "bg-gray-200"
                    }`}
                    style={{ maxWidth: "100px" }}
                  />
                )}
              </React.Fragment>
            ))}
          </div>
        </div>

        {/* Alert Messages */}
        {alert.msg && (
          <Alert
            variant={alert.type === "error" ? "destructive" : "default"}
            className="border-2"
          >
            {alert.type === "error" ? (
              <AlertCircle className="h-4 w-4" />
            ) : (
              <CheckCircle2 className="h-4 w-4" />
            )}
            <AlertDescription>{alert.msg}</AlertDescription>
          </Alert>
        )}

        {/* Form Content */}
        <div className="bg-white rounded-lg shadow-lg p-6">
          {select(formStates.step)}
        </div>

        {/* Duplicate alert for step 3 */}
        {formStates.step === 3 && alert.msg && (
          <Alert
            variant={alert.type === "error" ? "destructive" : "default"}
            className="border-2"
          >
            {alert.type === "error" ? (
              <AlertCircle className="h-4 w-4" />
            ) : (
              <CheckCircle2 className="h-4 w-4" />
            )}
            <AlertDescription>{alert.msg}</AlertDescription>
          </Alert>
        )}

        {/* Navigation Buttons */}
        <div className="flex justify-between items-center bg-white rounded-lg shadow-sm p-4">
          {viewPrev ? (
            <Button variant="outline" onClick={prevStep} size="lg">
              <ChevronLeft className="h-4 w-4 mr-2" />
              Previous
            </Button>
          ) : (
            <div />
          )}
          {viewNext && (
            <Button
              onClick={nextStep}
              size="lg"
              className="bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700"
            >
              Next
              <ChevronRight className="h-4 w-4 ml-2" />
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
